import { useMutation } from '@tanstack/react-query';
import { supabase } from '@readsavor/supabase-client';
/**
 * Hook for sending a password reset email using Supabase native functionality.
 */
export const useForgotPassword = () => {
    return useMutation({
        mutationFn: async ({ email }) => {
            // Directly use the Supabase client
            const { error } = await supabase.auth.resetPasswordForEmail(email, {
                // This URL should point to your app's password reset page
                redirectTo: `${window.location.origin}/reset-password`,
            });
            if (error) {
                // Re-throw the error to be caught by the mutation's onError handler
                throw error;
            }
        },
    });
};
//# sourceMappingURL=useForgotPassword.js.map